// @flow
import Notifications from '../constants/Notifications';
import type { CarouselImage } from '../interfaces/Image';
import CarouselSliderItemWrapper from './abstract/CarouselSliderItemWrapper';
import EventNames from '../constants/EventNames';

export default class CarouselSliderDetailComponent extends CarouselSliderItemWrapper {
  index: number = 0;
  min: number = 0;
  #scrollHandler: function;
  id: string = '';

  /**
   * Instantiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.#scrollHandler = this.onScroll.bind(this);
    this.addListener(Notifications.CAROUSEL_SCROLL_SLIDER, this.onChangeIndex.bind(this));
    this.addListener(Notifications.CAROUSEL_ADD_SCROLL_LISTENER, this.addScrollListener.bind(this));
    this.addEventListener(EventNames.SCROLL, this.#scrollHandler);

    const id = this.el.dataset.id;
    if (id) {
      this.id = id;
    }
    const defaultIndex = +this.el.dataset.index;
    if (defaultIndex) {
      this.index = defaultIndex;
      this.el.classList.remove('scroll-smooth');
      this.reposition({ index: this.index });
      this.el.classList.add('scroll-smooth');
    }
  }

  /**
   * Executes when the component is loaded
   */
  loaded() {
    this.notify(Notifications.CAROUSEL_CHILDREN_UPDATE, {
      count: this.items.length - 1
    });
    this.notify(Notifications.CAROUSEL_UPDATE_NAVIGATION, { index: this.index });
  }

  /**
   * @inheritDoc
   */
  handleUpdate({ product: { id } }: { product: { id: number } }): void {
    this.rebuildComponent(id);

    setTimeout(() => {
      const hasVariantImage = window.store.carouselMedia.some(
        (image: CarouselImage) => image.productId === id
      );

      this.notify(Notifications.UPDATE_CAROUSEL_BULLETS, {
        mediaCount: this.items.length
      });
      this.notify(Notifications.CAROUSEL_CHANGE_INDEX, {
        index: hasVariantImage ? 1 : 0
      });

      this.notify(Notifications.CAROUSEL_CHILDREN_UPDATE, {
        count: this.items.length - 1
      });
      // TODO: Research why the rule above needs to be minus 1 :'), little weird
    }, 0);
  }

  /**
   *
   */
  onScroll() {
    const scrollToIndex = this.el.scrollLeft / (this.el.scrollWidth / (this.el.children.length - 1));

    this.notify(Notifications.CAROUSEL_CHANGE_INDEX, { index: Math.round(scrollToIndex), id: this.id });
    this.notify(Notifications.RESET_ZOOM);
  }

  /**
   * @inheritDoc
   */
  reposition({ index }: { index: number }): void {
    let position = 0;

    try {
      position = this.el.children[index + 1].offsetLeft - parseInt(window.getComputedStyle(this.el).paddingLeft, 10);
    } catch {}

    this.el.scrollTo(position, 0);
  }

  /**
   *
   */
  onChangeIndex({ index, id }: { index: number, id: string }) {
    if (this.id === id) return;
    this.removeEventListener(EventNames.SCROLL, this.#scrollHandler);
    this.reposition({ index });
  }

  /**
   *
   */
  addScrollListener() {
    this.addEventListener(EventNames.SCROLL, this.#scrollHandler);
  }
}
